import {TableauPrix} from "@/components/Tableau/interface";
import {Palier} from "@/ts/interface/detailOffre";
import {PrixQuantitatif} from "@/ts/interface/detailOffre";

export function sortPalier(paliers: Palier[]): Palier[] {
  const currentPalier = paliers.slice();
  const sortPalier = currentPalier.sort((a, b) => {
    return a.nombre - b.nombre;
  });
  return sortPalier;
}

export function sortPrix(
  prixQuantitatif: PrixQuantitatif[],
): PrixQuantitatif[] {
  const currentPrix = prixQuantitatif.slice();
  const sortedPrixQuantitatif = currentPrix.sort((a, b) => {
    return a.quantite - b.quantite;
  });
  return sortedPrixQuantitatif;
}

export function formatPalierPrix(
  prixQuantitatif: PrixQuantitatif[],
  paliers: Palier[],
): TableauPrix[] {
  const sortedPrixQuantitatif: PrixQuantitatif[] = sortPrix(prixQuantitatif);
  const sortedPalier: Palier[] = sortPalier(paliers);

  let formatedData: TableauPrix[] | null = null;
  if (paliers.length > 0) {
    formatedData = sortedPalier.map(palier => {
      const palierValue: number | undefined =
        paliers.length === 1 && palier.nombre === 1 ? undefined : palier.nombre;
      const filtedPrix: string[] = sortedPrixQuantitatif.map(prixInQuantite => {
        const prixInPalier = prixInQuantite.prix.find(prix => {
          return prix.position === palier.position;
        });
        return prixInPalier?.valeur ? prixInPalier.valeur : "";
      });

      return {firstCell: palierValue, celules: filtedPrix};
    });
  } else {
    const allPrix: string[] = sortedPrixQuantitatif.map(prixQuantitatif => {
      return prixQuantitatif.prix[0].valeur;
    });
    formatedData = [{firstCell: undefined, celules: allPrix}];
  }
  return formatedData;
}
